var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"لیست انتقال وجه داخلی","params":_vm.params,"fields":_vm.fields,"btns":_vm.btns}})
}
var staticRenderFns = []

export { render, staticRenderFns }